
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earn/history",
      function () {
        return require("private-next-pages/earn/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/earn/history"])
      });
    }
  